import { render } from "./ZuLiZhiJianPage.vue?vue&type=template&id=0bac9a68&scoped=true"
import script from "./ZuLiZhiJianPage.vue?vue&type=script&lang=js"
export * from "./ZuLiZhiJianPage.vue?vue&type=script&lang=js"

import "./ZuLiZhiJianPage.vue?vue&type=style&index=0&id=0bac9a68&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bac9a68"]])

export default __exports__